import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import FormEditData from './form';
import { RegistrationCitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';

interface EditDataProps {
  disabled?: boolean;
}

const EditDataComponent = ({ disabled }: EditDataProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<RegistrationCitizenshipFormVM>();

  const onFieldEditDataChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('editDataControl', {
        ...formContext.values.editDataControl,
        [key]: value,
      });
    },
    [formContext.values.editDataControl, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-edit-data-control-content"
        id="panel-person-edit-data-control-header"
        expandIcon={<ExpandMore />}
      >
        {!!formContext.errors?.editDataControl ? (
          <Close color="error" />
        ) : (
          <Check color="success" />
        )}

        <Typography>Dati di controllo modifica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormEditData
          values={formContext.values.editDataControl}
          onChange={onFieldEditDataChange}
          errors={formContext.errors?.editDataControl as FormikErrors<AccordionEditDataControl>}
          touched={
            formContext.touched
              ?.editDataControl as unknown as FormikTouched<AccordionEditDataControl>
          }
          disabled={disabled}
        />
      </AccordionDetails>
    </Accordion>
  );
};

EditDataComponent.displayName = 'Accordion edit data control component';

const EditData = memo(EditDataComponent);

export default EditData;
